var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"small-section has-text-right is-size-7"},[_vm._v(" Powered by DataJoe ")])}
var staticRenderFns = []

export { render, staticRenderFns }